/* eslint-disable no-console */

import { register } from 'register-service-worker'


if (process.env.VUE_APP_NODE_ENV == 'production' || process.env.VUE_APP_NODE_ENV == 'development') {

  register(`${process.env.VUE_APP_BASE_ROUTE}service-worker.js`, {
    registrationOptions: {
      scope: process.env.VUE_APP_BASE_ROUTE,
    },
    ready () {
      console.log(
        // 'La aplicación está siendo servida desde la caché por el service worker.\n' +
        // 'Para más detalles, visita https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      // console.log('El service worker ha sido registrado')
      setInterval(() => {
        registration.update();
      }, 1000 * 60 * 60); // e.g. hourly checks
    },
    cached () {
      // console.log('El contenido del sitio ha sido almacenado en caché para uso offline')
    },
    updatefound () {
      // console.log('Nuevo contenido está siendo descargado')
    },
    updated (registration) {
      // console.log('Nuevo contenido del sitio está disponible; por favor recargue.');
      document.dispatchEvent(new CustomEvent('swUpdated', {detail: registration}))
    },
    offline () {
      // console.log('No se encuentra conectividad. La aplicación está corriendo en modo offline')
      // alert('offline');
    },
    error (error) {
      // console.error('Se presentó un error durante el registro del service worker:', error)
    }
  })
}
